import type { Doc } from "building-types/doc";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { componentInstanceChainFromId } from "../entity/componentInstanceEntityResolve";
import { isDocEntityBase } from "../entity/docEntityBaseTools";
import { docEntityHandleIsTableBased } from "../entity/docEntityHandleIsTableBased";
import { docEntityIsLabelable } from "../entity/docEntityHandleTools";
import type { DocEntityNode } from "../entity/docEntityNode";
import { DocEntityNodeRegistry } from "../entity/docEntityNodeRegistry";

function reportingUnitFromEntity(
  reportingUnitLabels: readonly string[],
  node: DocEntityNode | undefined,
): string | undefined {
  if (reportingUnitLabels.length === 0) {
    return undefined; // No reporting units to check
  }
  if (!node) {
    return undefined;
  }
  const docEntity = node.getDocEntity();
  if (docEntity && isDocEntityBase(docEntity) && docEntityIsLabelable(docEntity)) {
    for (const reportingUnitLabel of reportingUnitLabels) {
      if (docEntity.labels?.[reportingUnitLabel]) {
        return reportingUnitLabel;
      }
    }
  }
  return reportingUnitFromEntity(reportingUnitLabels, node.getParent());
}

function reportingUnitLabelFromEntityHandle(
  doc: Doc,
  reportingUnitLabels: readonly string[],
  entityHandle: DocEntityHandle,
): string | undefined {
  const node = DocEntityNodeRegistry.getNode(doc, entityHandle);
  return reportingUnitFromEntity(reportingUnitLabels, node);
}

export function reportingUnitLabelFromEntityId(
  doc: Doc,
  reportingUnitLabels: readonly string[],
  entityHandle: DocEntityHandle | undefined,
): string | undefined {
  if (!entityHandle) {
    return undefined;
  }

  if (docEntityHandleIsTableBased(entityHandle)) {
    const componentInstanceChain = componentInstanceChainFromId(entityHandle.id);
    if (componentInstanceChain && componentInstanceChain[0]) {
      return reportingUnitLabelFromEntityHandle(doc, reportingUnitLabels, {
        type: "COMPONENT_INSTANCE",
        id: componentInstanceChain[0],
      });
    }
  }
  return reportingUnitLabelFromEntityHandle(doc, reportingUnitLabels, entityHandle);
}
